var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"align-start fill-height",attrs:{"fluid":""}},[_c('navbar',{staticClass:"app-bar"}),_c('v-main',{staticClass:"mx-auto"},[_c('router-view')],1),_c('cepp-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }